import { MutationTree } from 'vuex'
import { AuthState } from './types'
import * as types from './mutationType'

export const mutations: MutationTree<AuthState> = {
  handler: () => {},
  [types.SET_USER_DATA] (state: any, res: any) {
    state.uid = res.uid
    state.name = res.name
    state.email = res.email
    state.picture = res.picture
    state.signInMethod = res.signInMethod
  },
  [types.SET_ACCESS_TOKEN] (state: any, res: string) {
    state.accessToken = res
  },
  [types.SET_REFRESH_TOKEN] (state: any, res: string) {
    state.refreshToken = res
  },
  [types.SET_CUSTOMER_NAME] (state: any, res: string) {
    state.customerName = res
  },
  [types.SET_CUSTOMER_SETTING] (state: any, res: Object) {
    state.customerSetting = Object.assign({}, res)
  },
  [types.SET_LICENSE_LIST] (state: any, data: any) {
    state.licenseList = [].concat(data)
  },
  [types.SET_ROLE] (state: any, role: string) {
    state.role = role
  },
  [types.SET_IS_ABEJA_ADMIN] (state: any, flag: boolean) {
    state.isAbejaAdmin = flag
  },
  [types.SET_IS_NEW_USER] (state: any, flag: boolean) {
    state.isNewUser = flag
  },

  [types.SET_LOGIN_STATE] (state: any, res: any) {
    state.isNewUser = res.isNewUser
    state.email = res.email
    state.name = res.name
    state.picture = res.picture
    state.signInMethod = res.signInMethod
    state.uid = res.uid
    state.accessToken = res.accessToken
  },
  [types.SET_CURRENT_USER] (state: any, res: any) {
    console.log('SET_CURRENT_USER', res)
    state.email = res.email
    state.name = res.name
    state.picture = res.picture
    state.uid = res.uid
    state.signInMethod = res.signInMethod
    state.refreshToken = res.refreshToken
  },
  [types.LOGIN_GOOGLE] (state: any, res: any) {
    state.isNewUser = res.isNewUser
    state.email = res.email
    state.name = res.name
    state.picture = res.picture
    state.signInMethod = res.signInMethod
    state.uid = res.uid
    state.accessToken = res.accessToken
  },
  [types.LOGIN_MICROSOFT] () {
    console.log('call LOGIN_MICROSOFT')
  },
  [types.LOGOUT_GOOGLE] (state: any) {
    state.uid = ''
    state.name = ''
    state.email = ''
    state.picture = ''
    state.signInMethod = ''
    state.customerName = ''
    state.customerSetting = {
      customerId: null,
      country: '',
      externalServiceId: null,
      phone: '',
      postCode: '',
      purchaseType: '',
      representativeUserName: '',
      address: ''
    },
    state.role = 'Member'
    state.isAbejaAdmin = false
    state.isNewUser = false
    state.accessToken = ''
    state.refreshToken = ''
  },
  [types.LOGOUT_MICROSOFT] (state: any) {
    state.uid = ''
    state.name = ''
    state.email = ''
    state.picture = ''
    state.signInMethod = ''
    state.customerName = ''
    state.customerSetting = {
      customerId: null,
      country: '',
      externalServiceId: null,
      phone: '',
      postCode: '',
      purchaseType: '',
      representativeUserName: '',
      address: ''
    },
    state.role = 'Member'
    state.isAbejaAdmin = false
    state.isNewUser = false
    state.accessToken = ''
    state.refreshToken = ''
  },
  [types.SET_SELECTED_CUSTOMER] (state: any, res: any) {
    state.selectedCustomer = Object.assign({}, res)
  }
}
